module.exports = __webpack_public_path__ + "static/img/contactService.2859c0a.gif";


//////////////////
// WEBPACK FOOTER
// ./static/image/contactService.gif
// module id = Xt+a
// module chunks = 1